import React, { useState } from 'react';
import { connect } from 'dva';

import { Typography } from '@hulu/react-style-components';

import { permissionManagerColumns } from '../Templates/columns';
import { FormWrapper, PermissionManagerWrapper, Y_SCROLL } from './styles';
import { PERMISSION_MANAGER_TABLE, PERMISSION_MANAGER_VIEW_ROLES } from '../../testUtils';
import { ResizableTable } from '../../utils';
import { SearchOutlined } from '@ant-design/icons';
import { convertUserDataToTableData } from './utils';
import GridLayout from '../Templates/GridLayout';
import { ButtonWrapper, LeftSideHeaderWrapper } from '../AdsTracer/Header/styles';
import { Form, Input, Row, Spin } from 'antd';

const ViewUsers = ({ dispatch, userData = [], permissionWidths = [], loading }) => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedUserRoles, setSelectedUserRoles] = useState([]);
  const [form] = Form.useForm();
  const tableData = Object.entries(userData).map(convertUserDataToTableData);
  const LEFT_HAND_SPAN = 10;
  const RIGHT_HAND_SPAN = 14;
  const handleWidthChange = (widths) =>
    dispatch({
      type: 'permissionManager/updatePermissionManagerWidths',
      payload: widths,
    });
  const handleSelectedUser = (selectedRowKeys, selectedRows) => {
    let roles = selectedRows[0]?.roles || [];
    setSelectedUser(selectedRowKeys[0]);
    if (typeof roles === 'string') {
      roles = roles.split(',').map((role) => role.trim());
    }
    setSelectedUserRoles(roles);
  };

  return (
    <PermissionManagerWrapper>
      <Typography variant={'h2'}>Permission Manager</Typography>
      <br />
      <>
        <Spin spinning={loading}>
          <GridLayout
            leftHandSpan={LEFT_HAND_SPAN}
            rightHandSpan={RIGHT_HAND_SPAN}
            headerChildren={
              <LeftSideHeaderWrapper>
                <ButtonWrapper icon="IconAdd">New User</ButtonWrapper>
              </LeftSideHeaderWrapper>
            }
            leftHandChildren={
              <div data-testid={PERMISSION_MANAGER_TABLE}>
                <ResizableTable
                  dataSource={tableData.map((t) => ({ ...t, key: t['email-id'] }))}
                  inputColumns={permissionManagerColumns(tableData, permissionWidths)}
                  rowSelection={{
                    type: 'radio',
                    selectedRowKeys: [selectedUser],
                    onChange: handleSelectedUser,
                  }}
                  scroll={Y_SCROLL}
                  widthHandler={handleWidthChange}
                  searchableProps={{
                    inputProps: {
                      placeholder: 'Search in table...',
                      prefix: <SearchOutlined />,
                    },
                    searchFunction(dataSource, searchTerm) {
                      return (dataSource ?? []).filter((row) => {
                        return Object.values(row).some((val) => {
                          const performSearch = (searchVal) => {
                            return searchVal.toString().toLowerCase().includes(searchTerm.toLowerCase());
                          };

                          if (Array.isArray(val)) {
                            return val.forEach(performSearch);
                          }
                          return performSearch(val);
                        });
                      });
                    },
                  }}
                />
              </div>
            }
            rightHandChildren={
              selectedUser && (
                <div data-testid={PERMISSION_MANAGER_VIEW_ROLES}>
                  <FormWrapper id="DisplayRoles" form={form} onFinish={null}>
                    <Row gutter={16}>
                      <Typography variant="h5">Edit Roles for user {selectedUser}</Typography>
                    </Row>
                    <br />
                    <br />
                    <Row gutter={16}>
                      <Typography variant="h5">Roles</Typography>
                    </Row>
                    <Row gutter={16}>
                      <Input placeholder="Search roles..." prefix={<SearchOutlined />} />
                    </Row>
                    <br />
                    {selectedUserRoles.map((role, index) => (
                      <Row gutter={16} key={index}>
                        {role}
                      </Row>
                    ))}
                  </FormWrapper>
                </div>
              )
            }
          />
        </Spin>
      </>
    </PermissionManagerWrapper>
  );
};

function mapStateToProps({ app, permissionManager, loading }) {
  return {
    permissions: app.currentUser.permissions,
    userData: permissionManager.userData,
    permissionWidths: permissionManager.permissionWidths,
    loading: loading.effects['permissionManager/fetchUsers'],
  };
}

export default connect(mapStateToProps)(ViewUsers);
